import { render } from "./AiPromptManagement.vue?vue&type=template&id=54ebb512&scoped=true"
import script from "./AiPromptManagement.vue?vue&type=script&lang=js"
export * from "./AiPromptManagement.vue?vue&type=script&lang=js"

import "./AiPromptManagement.vue?vue&type=style&index=0&id=54ebb512&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54ebb512"]])

export default __exports__